import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { homeBannerData } from '@/mocks/tv-shows';

export default function HeroSection() {
  const [currentBanner, setCurrentBanner] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goToSlide = useCallback((index: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentBanner(index);
    setTimeout(() => setIsTransitioning(false), 600);
  }, [isTransitioning]);

  useEffect(() => {
    const timer = setInterval(() => {
      goToSlide((currentBanner + 1) % homeBannerData.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [currentBanner, goToSlide]);

  return (
    <section className="relative w-full h-[550px] md:h-[680px] overflow-hidden">
      {homeBannerData.map((banner, idx) => (
        <div
          key={banner.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            idx === currentBanner ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
        >
          <img
            src={banner.imageUrl}
            alt={banner.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/25 to-black/60"></div>

      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
        <div className="w-full max-w-3xl">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight transition-all duration-500">
            <strong>{homeBannerData[currentBanner].title}</strong>
          </h1>
          <p className="text-lg md:text-xl text-white/80 mb-8 transition-all duration-500">
            {homeBannerData[currentBanner].subtitle}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
            <Link
              to={homeBannerData[currentBanner].link}
              className="flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full text-base transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
            >
              <i className="ri-play-circle-line text-xl"></i>
              立即观看
            </Link>
            <Link
              to="/category/all"
              className="flex items-center gap-2 px-8 py-3.5 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-medium rounded-full text-base transition-all duration-200 whitespace-nowrap cursor-pointer border border-white/20"
            >
              <i className="ri-list-check-2 text-lg"></i>
              浏览全部
            </Link>
          </div>

          <div className="flex items-center justify-center gap-2">
            {homeBannerData.map((_, idx) => (
              <button
                key={idx}
                onClick={() => goToSlide(idx)}
                className={`transition-all duration-300 rounded-full cursor-pointer ${
                  idx === currentBanner
                    ? 'w-8 h-2.5 bg-primary-500'
                    : 'w-2.5 h-2.5 bg-white/40 hover:bg-white/70'
                }`}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-4 right-4 flex justify-center">
        <div className="flex items-center gap-3 px-5 py-2.5 bg-white/10 backdrop-blur-md rounded-full border border-white/15">
          <i className="ri-search-line text-white/70 text-sm"></i>
          <input
            type="text"
            placeholder="搜索你想看的电视剧..."
            className="bg-transparent text-white placeholder-white/50 text-sm outline-none border-none w-48 md:w-64"
          />
          <button className="w-7 h-7 flex items-center justify-center bg-primary-500 rounded-full cursor-pointer" aria-label="搜索">
            <i className="ri-arrow-right-line text-white text-sm"></i>
          </button>
        </div>
      </div>
    </section>
  );
}